import { useEffect, useState } from 'react';

function isOnline(): boolean {
  return typeof navigator === 'undefined' || navigator.onLine !== false;
}

export function OfflineBanner() {
  const [online, setOnline] = useState(isOnline);

  useEffect(() => {
    function updateStatus() {
      setOnline(isOnline());
    }

    window.addEventListener('online', updateStatus);
    window.addEventListener('offline', updateStatus);
    return () => {
      window.removeEventListener('online', updateStatus);
      window.removeEventListener('offline', updateStatus);
    };
  }, []);

  return online ? null : (
    <div className="offline-banner" role="status" aria-live="polite">
      Mất kết nối mạng. Nội dung viết trên bảng vẫn được lưu trên thiết bị.
    </div>
  );
}
